<script>

	import { onMount } from 'svelte';
	import { fade } from 'svelte/transition';

	import Brand from './ui/Brand.svelte';
	import Button from './ui/Button.svelte';

	import { event, showSettings, session, spotlight, settings, revealMasthead } from './lib/stores.js';

	let mounted = false;

	onMount(() => {
		setTimeout(() => {
			mounted = true;
		}, 100);
	});

</script>

<style>

	.masthead {
		flex: 0 0 auto;
		background: var(--mastheadBgColor, '#fff');
		color: var(--mastheadIconColor, '#000');
		padding-top: calc(1rem + env(safe-area-inset-top));
		padding-bottom: 1rem;
		box-sizing: border-box;
		transform: translateY(calc(-5rem - 2px));
		transition: transform 0.3s ease;
		border-bottom: 1px solid var(--blend-10);
		position: relative;
		z-index: 1000;
	}

	.masthead.show {
		transform: translateY(0);
	}

	.inner {
		padding: 0 1rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	ul {
		display: flex;
		align-items: flex-start;
		margin: 0 auto;
		padding: 0;
	}

	.utils {
		padding: 0;
	}

	.utils ul {
		justify-content: flex-end;
	}

	.utils :global(li) {
		display: block;
		margin: 0 0 0 1.2rem;
	}

	.utils :global(button),
	.utils :global(button.subtle) {
		color: var(--mastheadIconColor);
	}

</style>

{#if $event}
	<div id="masthead" class="masthead" class:show={mounted && !($spotlight && (($settings.mode == 'av') || ($settings.displaySpotlight))) && !(($settings.mode == 'av') && !$revealMasthead)}>
		<div class="inner">
			<Brand/>
			<div class="utils">
				<ul>
					<li>
						<Button subtle={true} on:click={() => { $session = null; $spotlight = null; }}>
							<svg viewBox="0 0 80 80">
								{#if $session}
									<path d="m62.7 18.2h-10.7v-3.8c0-1.1-.9-2-2-2s-2 .9-2 2v3.8h-16v-3.8c0-1.1-.9-2-2-2s-2 .9-2 2v3.8h-10.7c-2.2 0-4 1.8-4 4v41.4c0 2.2 1.8 4 4 4h45.3c2.2 0 4-1.8 4-4v-41.4c.1-2.2-1.7-4-3.9-4zm0 43.4c0 1.1-.9 2-2 2h-41.4c-1.1 0-2-.9-2-2v-37.4c0-1.1.9-2 2-2h8.7v3.8c0 1.1.9 2 2 2s2-.9 2-2v-3.8h16v3.8c0 1.1.9 2 2 2s2-.9 2-2v-3.8h8.7c1.1 0 2 .9 2 2z"/><path d="m52.5 40h-25c-1.1 0-2-.9-2-2s.9-2 2-2h25c1.1 0 2 .9 2 2s-.9 2-2 2z"/><path d="m52.5 48h-25c-1.1 0-2-.9-2-2s.9-2 2-2h25c1.1 0 2 .9 2 2s-.9 2-2 2z"/><path d="m52.5 56h-25c-1.1 0-2-.9-2-2s.9-2 2-2h25c1.1 0 2 .9 2 2s-.9 2-2 2z"/>
								{:else}
									<path d="m62.7 18.2h-10.7v-3.8c0-1.1-.9-2-2-2s-2 .9-2 2v3.8h-16v-3.8c0-1.1-.9-2-2-2s-2 .9-2 2v3.8h-10.7c-2.2 0-4 1.8-4 4v41.4c0 2.2 1.8 4 4 4h45.3c2.2 0 4-1.8 4-4v-41.4c.1-2.2-1.7-4-3.9-4zm-10.2 37.8h-25c-1.1 0-2-.9-2-2s.9-2 2-2h25c1.1 0 2 .9 2 2s-.9 2-2 2zm0-8h-25c-1.1 0-2-.9-2-2s.9-2 2-2h25c1.1 0 2 .9 2 2s-.9 2-2 2zm0-8h-25c-1.1 0-2-.9-2-2s.9-2 2-2h25c1.1 0 2 .9 2 2s-.9 2-2 2z"/>
								{/if}
							</svg>
						</Button>
					</li>	
					<li>
						<Button subtle={true} on:click={() => { $showSettings = !$showSettings }}>
							<svg viewBox="0 0 80 80">
								{#if $showSettings}
									<path d="m66 38.9-.8-5.4c-.3-1.8-1.8-3.3-3.7-3.4l-3.9-.3c-.5-1-1.1-1.8-1.8-2.7-.6-.7-1.2-1.4-2-2.1l.6-3.9c.3-1.8-.8-3.6-2.5-4.3l-5.1-2c-.8-.3-1.6-.4-2.4-.2-.9.2-1.8.8-2.3 1.6l-2.1 3.3c-1.6 0-3.2.2-4.9.6-.4.1-.7.2-1.1.3l-3-2.4c-1.1-.8-2.3-1-3.5-.8-.5.1-1.1.4-1.5.8l-4.3 3.4c-1.5 1.2-1.9 3.2-1.1 4.9l1.7 3.5c-1 1.8-1.8 3.7-2.3 5.6l-3.6 1.4c-1.7.7-2.8 2.5-2.5 4.3l.8 5.4c.3 1.8 1.8 3.3 3.7 3.4l3.9.3c.5 1 1.1 1.9 1.8 2.7.6.7 1.2 1.4 2 2.1l-.6 3.8c-.3 1.8.8 3.6 2.5 4.3l5.1 2c.8.3 1.6.4 2.4.2.9-.2 1.8-.8 2.3-1.6l2.2-3.2c1.6 0 3.2-.2 4.8-.6.4-.1.8-.2 1.1-.3l3.1 2.4c1 .8 2.3 1 3.5.8.5-.1 1.1-.4 1.5-.8l4.3-3.4c1.5-1.2 1.9-3.2 1.1-4.9l-1.7-3.5c1-1.8 1.8-3.7 2.2-5.6l3.6-1.4c1.7-.7 2.8-2.5 2.5-4.3zm-26 11.4c-5.7 0-10.2-4.6-10.2-10.2 0-5.7 4.6-10.2 10.2-10.2s10.2 4.5 10.2 10.1c0 5.7-4.6 10.3-10.2 10.3z"/><circle cx="40" cy="40" r="6.2"/>
								{:else}
									<path d="m40 50.3c-5.7 0-10.2-4.6-10.2-10.2 0-5.7 4.6-10.2 10.2-10.2s10.2 4.5 10.2 10.1c0 5.7-4.6 10.3-10.2 10.3zm0-16.5c-3.4 0-6.2 2.8-6.2 6.2s2.8 6.2 6.2 6.2 6.2-2.8 6.2-6.2-2.8-6.2-6.2-6.2z"/><path d="m28.4 21.1 4.8 3.9c.9-.4 1.8-.7 2.8-1 1.9-.5 3.9-.6 5.9-.4l3.5-5.1 5.1 2-.9 6.1c1.1.8 2.2 1.8 3.2 2.9 1 1.2 1.7 2.6 2.3 4l6.2.5.8 5.4-5.7 2.2c-.3 2.9-1.4 5.8-3.3 8.2l2.7 5.6-4.3 3.4-4.8-3.8c-.9.4-1.9.7-2.8 1-1.9.5-3.9.6-5.9.4l-3.5 5.1-5.1-2 .9-6.1c-1.1-.8-2.2-1.8-3.2-2.9-1-1.2-1.7-2.6-2.3-4l-6.1-.5-.8-5.4 5.7-2.2c.3-3 1.4-5.8 3.3-8.2l-2.7-5.6zm-.9-3.9c-.5.1-1.1.4-1.5.8l-4.3 3.4c-1.5 1.2-1.9 3.2-1.1 4.9l1.7 3.5c-1 1.8-1.8 3.7-2.3 5.6l-3.6 1.4c-1.7.7-2.8 2.5-2.5 4.3l.8 5.4c.3 1.8 1.8 3.3 3.7 3.4l3.9.3c.5 1 1.1 1.9 1.8 2.7.6.7 1.2 1.4 2 2.1l-.6 3.8c-.3 1.8.8 3.6 2.5 4.3l5.1 2c.8.3 1.6.4 2.4.2.9-.2 1.8-.8 2.3-1.6l2.2-3.2c1.6 0 3.2-.2 4.8-.6.4-.1.8-.2 1.1-.3l3.1 2.4c1 .8 2.3 1 3.5.8.5-.1 1.1-.4 1.5-.8l4.3-3.4c1.5-1.2 1.9-3.2 1.1-4.9l-1.7-3.5c1-1.8 1.8-3.7 2.2-5.6l3.6-1.4c1.7-.7 2.8-2.5 2.5-4.3l-.8-5.4c-.3-1.8-1.8-3.3-3.7-3.4l-3.9-.3c-.5-1-1.1-1.8-1.8-2.7-.6-.7-1.2-1.4-2-2.1l.6-3.9c.3-1.8-.8-3.6-2.5-4.3l-5.1-2c-.8-.3-1.6-.4-2.4-.2-.9.2-1.8.8-2.3 1.6l-2.1 3.3c-1.6 0-3.2.2-4.9.6-.4.1-.7.2-1.1.3l-3-2.4c-1.1-.8-2.3-1-3.5-.8z"/>
								{/if}
							</svg>
						</Button>
					</li>	
				</ul>
			</div>
		</div>
	</div>
{/if}